import React from 'react';

import withAppState from '../mobx/withAppState';

import Loading from './Loading';
import Login from './Login';
import VoucherCodeInput from './VoucherCodeInput';

import Modal from './Modal';

import makeCancelable from '../helpers/PromiseWrapper';
import { getCsrfToken, handleCsrfFailure } from '../helpers/GetCsrfToken';

class ApplyVoucher extends React.Component {
  constructor() {
    super();
    this.state = {
      results: null,
      loading: false,
      inputButtonLoading: false,
      selectedVoucher: {},
      oIndex: '',
      vIndex: '',
      oImage: '',
      oTitle: '',
      oDescription: '',
      voucherCodeLogin: true
    };
    this.requests = [];
  }

  setLoading(value) {
    this.setState({ loading: value });
  }
  
  lookupVouchers() {
    const { customer, restaurant } = this.props;
    if (!!customer && !!customer.id) {
      this.setState({
        loading: true
      });
      fetch(
        `api/Offers/GetOffers/${customer.emailAddress}/${restaurant.id}`
      ).then(response => {
        this.setState({
          loading: false
        });
        if (response.status === 200) {
          response.json().then(data => {
            this.setState({
              results: data.offers
            });
          })
        }
      });
    }
  }

  componentDidMount() {
    this.lookupVouchers();
  }

  componentWillUnmount() {
    for (let i = 0; i < this.requests.length; i++) {
      this.requests[i].cancel();
    }
  }

  setLoading(value, wasInputButton) {
    if (wasInputButton) {
      this.setState({ inputButtonLoading: value });
    } else {
      this.setState({ loading: value });
    }
  }

  handleOfferSelect(voucherCode, wasInputButton = false) {
    const { restaurant, bill } = this.props;
    this.setLoading(true, wasInputButton);
    var data = JSON.stringify({
      voucherCode: voucherCode,
      restaurantId: restaurant.id,
      bill: bill[0]
    });

    let request = makeCancelable(
      fetch('api/Offers/ApplyVoucher/', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-XSRF-TOKEN': getCsrfToken(),
        },
        body: data
      })
    );
    this.requests.push(request);
    request
      .then(async response => {
        if (response.status === 200) {
          await this.props.handleApplyVoucherSuccessResponse(response);
        } else if (response.status === 400) {
          handleCsrfFailure();
        } else {
          this.props.setErrorModalMessage(
            'We were unable to apply this voucher code.'
          );
        }
        this.setLoading(false, wasInputButton);
      })
      .catch(err => {
        this.setLoading(false, wasInputButton);
      });
  }

  openModal(voucher) {
    this.props.setMainModalCTA(() => this.handleOfferSelect(voucher.code));

    const title = 'Apply the following voucher?';
    const voucherCode = voucher.code;
    const message = 'This cannot be undone.';
    const mainCTAText = 'Confirm';
    const secondaryCTAText = 'Cancel';
    this.props.setupMainModal({ title, message, voucherCode, mainCTAText, secondaryCTAText });
    this.props.enableMainModal();
  }

  displayResults() {
    if (this.state.results !== null) {
      var offers = this.state.results;
      if (offers.length > 0) {
        return offers.map((offer, oIndex) => {
          const voucherCodes = offer.voucherCodes;
          if (voucherCodes.length > 0) {
            return voucherCodes.map((voucher, vIndex) => {
              return (
                <div
                  key={vIndex}
                  className={`voucher-card ${!offer.imgURL ? 'no-image' : null}`}
                  onClick={() => this.openModal(voucher)}
                >
                  {!!offer.imgURL ? (
                    <div
                      className="voucher-card-image"
                      style={{ backgroundImage: `url(${offer.imgURL} )` }}
                    ></div>
                  ) : null}
                  <div className={`voucher-card-description`}>
                    <h3 className="title">{offer.title}</h3>
                    <p className="description">{offer.description}</p>
                    <p className="code">{voucher.code}</p>
                  </div>
                </div>
              );
            });
          } else {
            return null;
          }
        });
      }
      return (
        <div className="title-message">
          <h3>No applicable vouchers found.</h3>
        </div>
      );
    }
  }

  voucherLoginViewSwitch() {
    this.setState({
      voucherCodeLogin: !this.state.voucherCodeLogin
    });
  }

  handleLogin(data) {
    this.props.loginAsCustomer(data);
    this.lookupVouchers();
  }

  render() {
    const {
      customer,
      signUp,
      goToForgottenPassword,
      bufferedAction,
    } = this.props;

    return !customer || !customer.id ? (
      <div className="voucher-login">
        {this.state.voucherCodeLogin === true ? (
          <div className="voucher-code">
            <VoucherCodeInput
              loading={this.state.inputButtonLoading}
              handleOfferSelect={this.handleOfferSelect.bind(this)}
            />
            {this.props.getCanSignup() &&
            <div className="login-button-container">
              <button
                className="btn btn-secondary login-button"
                onClick={() => this.voucherLoginViewSwitch()}
              >
                Log in to redeem a saved voucher
              </button>
            </div>}
          </div>
        ) : (
            <div className="voucher-login-inner">
              <Login
                bufferedAction={bufferedAction}
                goToForgottenPassword={goToForgottenPassword}
                handleLogin={(data) => this.handleLogin(data)}
                signUp={signUp}
              />
            </div>
          )}
      </div>
    ) : (
        <div className="apply-voucher">
          {this.state.loading === true && (
            <div className="loading-container">
              <Loading />
            </div>
          )}

          {this.state.display === true && <Modal /> ? (
            <Modal selectedVoucher={this.state.selectedVoucher} />
          ) : (
              ''
            )}

          <div className="voucher-list">
            {this.displayResults()}
            <VoucherCodeInput
              loading={this.state.inputButtonLoading}
              handleOfferSelect={this.handleOfferSelect.bind(this)}
            />
          </div>
        </div>
      );
  }
}

export default withAppState(ApplyVoucher,
  {
    mobXProps: ({
      customer,
      restaurant,
      bill,
      modalActive,
      modalTitle,
      modalVoucherCode,
      modalMessage,
      modalMainCTAText,
      modalSecondaryCTAText,
    }) => ({
      customer,
      restaurant,
      bill,
      modalActive,
      modalTitle,
      modalVoucherCode,
      modalMessage,
      modalMainCTAText,
      modalSecondaryCTAText,
    }),
    mobXActions: ({
      setErrorModalMessage,
      enableMainModal,
      setupMainModal,
      setMainModalCTA,
      loginAsCustomer,
      getCanSignup
    }) => ({
      setErrorModalMessage,
      enableMainModal,
      setupMainModal,
      setMainModalCTA,
      loginAsCustomer,
      getCanSignup
    })
  }
);
